import { atom } from 'nanostores';

export const $isTermsIsOpen = atom(false);
export const $isPrivacyOpen = atom(false);